import { GROWTH_STATUSES, GROWTH_STATUS, growthSeverity, GROWTH_STATUS_DEFAULT } from './growthStatus';

export const GENDERS = ['Male', 'Female'];

export const DELIVERY_WAYS = ['Normal', 'Caesarean', 'Vacuum', 'Forceps'];

export const VACCINATION_STATUSES = ['Completed', 'Upcoming', 'Due', 'Overdue', 'Action'];

export const VACCINATION_PLACES = [
    'MOH Clinic',
    'Hospital',
    'Private Clinic',
    'Outreach Clinic',
];

export const BCG_MARKS = ['Yes', 'No', 'Pending'];

export { GROWTH_STATUSES, GROWTH_STATUS, growthSeverity, GROWTH_STATUS_DEFAULT };

/**
 * Filter categories shown in the Profiles page dropdown.
 * Includes growth statuses, vaccination statuses, and grouping helpers.
 */
export const PROFILE_FILTERS = [
    'All',
    'Infant',
    'Child',
    'Overdue',
    'Upcoming',
    'Due',
    'Up to Date',
    ...GROWTH_STATUSES,
];